import { Component } from '@angular/core';
import { RidButton } from '../../../components/rid-button/rid-button';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-morpheme-board-page',
  imports: [RidButton, RidDemoPage],
  templateUrl: './morpheme-board-page.html',
})
export class MorphemeBoardPage {}
